import { Box, Circle, Text, CircularProgress } from "@chakra-ui/react";
import { ReactComponent as FlagIcon } from '../../svg/flag-icon.svg'
import { ReactComponent as Quiz } from '../../svg/puzzle-piece.svg'
import { ReactComponent as Assessments } from '../../svg/assessment-colored.svg'
import { ReactComponent as Certificates } from '../../svg/certificate.svg'
import { ReactComponent as ScorePoints } from '../../svg/scorepoints.svg'
import { ReactComponent as Trophy } from '../../svg/trophy.svg'
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadStatistics } from "../../redux/api/apiCalls";

export default function IncourseStatics() {
    const dispatch = useDispatch()
    const { statisticsData, isLoading } = useSelector(state => state.statisticsState)

    useEffect(() => {
        dispatch(loadStatistics())
        // eslint-disable-next-line
    }, [])
    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
            mb='1.5rem'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                Incourse Statics
            </Text>


            <Box
                w='100%'
                d='flex'
                justifyContent='space-between'
            >

                <Box
                    borderRadius='10px'
                    w='18%'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    bg='#FCE4F0'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='50px' bg='#ffffff' mb='0.5rem'>
                        <ScorePoints fill='#FA82BB' />
                    </Circle>
                    <Text
                        color='#FA82BB'
                        fontSize='15px'
                        fontWeight='700'
                        mb='0.5rem'
                    >
                        Score Points Earned
                    </Text>
                    <Text
                        fontSize='20px'
                        fontWeight='800'
                        color='#222222'
                    >
                        {isLoading && !statisticsData ? <CircularProgress size='20px' isIndeterminate color='#000000' /> : statisticsData?.in_course_statistics[0]?.total_score_point}
                    </Text>
                </Box>

                <Box
                    borderRadius='10px'
                    w='18%'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    bg='#FDECD4'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='50px' bg='#ffffff' mb='0.5rem'>
                        <FlagIcon />
                    </Circle>
                    <Text
                        color='#EABB78'
                        fontSize='15px'
                        fontWeight='700'
                        mb='0.5rem'
                    >
                        Current Milestone
                    </Text>
                    <Text
                        fontSize='20px'
                        fontWeight='800'
                        color='#222222'
                    >
                        {isLoading && !statisticsData ? <CircularProgress size='20px' isIndeterminate color='#000000' /> : statisticsData?.in_course_statistics[0]?.courses_enrolled}
                    </Text>
                </Box>

                <Box
                    borderRadius='10px'
                    w='18%'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    bg='#F9E4E3'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='50px' bg='#ffffff' mb='0.5rem'>
                        <Quiz stroke='#E04D4A' fill='#E04D4A' width='20px' height='20px' />
                    </Circle>
                    <Text
                        color='#967132'
                        fontSize='15px'
                        fontWeight='700'
                        mb='0.5rem'
                    >
                        Quizzes
                    </Text>
                    <Text
                        fontSize='20px'
                        fontWeight='800'
                        color='#222222'
                    >
                        {isLoading && !statisticsData ? <CircularProgress size='20px' isIndeterminate color='#000000' /> : statisticsData?.in_course_statistics[0]?.quizz_completed}
                    </Text>
                </Box>

                <Box
                    borderRadius='10px'
                    w='18%'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    bg='#F0E9FF'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='50px' bg='#ffffff' mb='0.5rem'>
                        <Assessments />
                    </Circle>
                    <Text
                        color='#7958C9'
                        fontSize='15px'
                        fontWeight='700'
                        mb='0.5rem'
                    >
                        Assessments
                    </Text>
                    <Text
                        fontSize='20px'
                        fontWeight='800'
                        color='#222222'
                    >
                        {isLoading && !statisticsData ? <CircularProgress size='20px' isIndeterminate color='#000000' /> : statisticsData?.in_course_statistics[0]?.assessments_completed}
                    </Text>
                </Box>

                <Box
                    borderRadius='10px'
                    w='18%'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    bg='#E1F0E9'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='50px' bg='#ffffff' mb='0.5rem'>
                        <Certificates width='20px' height='20px' fill='#26CE83' />
                    </Circle>
                    <Text
                        color='#26CE83'
                        fontSize='15px'
                        fontWeight='700'
                        mb='0.5rem'
                    >
                        Certificates
                    </Text>
                    <Box d='flex' alignItems = 'center'>
                        <Text
                            fontSize='20px'
                            fontWeight='800'
                            color='#222222'
                            mr = '1rem'
                        >
                            {isLoading && !statisticsData ? <CircularProgress size='20px' isIndeterminate color='#000000' /> : statisticsData?.in_course_statistics[0]?.certificates_earned}
                        </Text>
                        <Trophy />
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}